import { useLogRocket } from 'hooks/use-logrocket';

export const Tracking = () => {
  useLogRocket();
  return <></>;
};
